<script lang="ts">
    import CN from "classnames";

    export let text: string;
    export let ariaLabel: string;
    export let checked: boolean;
</script>

<label class={CN("gw-form-checkbox", { "gw-form-checkbox--checked": checked })}>
    <input
        type="checkbox"
        aria-checked="false"
        class="gw-form-checkbox__input"
        aria-label={ariaLabel}
        {checked}
        on:change
    />
    <span class="gw-form-checkbox__text">{text}</span>
</label>

<style lang="postcss">
    .gw-form-checkbox {
        display: flex;
        align-items: center;
        padding: 0.5em 1em;
        border: 1px solid #d0d5dd;
        border-radius: 0.5em;
        cursor: pointer;
        background-color: #fff;
        transition: background-color 0.1s ease, box-shadow 0.1s ease;

        &--checked {
            background-color: #e4e7ec;
            color: #1a1b1d;
            border: 1px solid #d0d5dd;
        }

        &:focus-within {
            outline: 1px solid #d0d5dd;
        }
        &:hover {
            background: rgba(242, 244, 247, 0.7);
        }

        &__input {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(0 0 0 0);
        }

        &__text {
            font-size: 0.75em;
        }
    }
</style>
